import styled from "styled-components";
import { responsiveWidth } from "responsive";

const FONT = `"SpoqaHanSansNeo-Regular", "Apple SD Gothic Neo", sans-serif`;

export const Wrapper = styled.div`
  background: linear-gradient(180deg, #0a0a0a 0%, #111111 100%);
  color: #cfcfcf;
  display: flex;
  flex-direction: column;
  width: 100%;
  position: relative;
  pointer-events: auto;

  &.footer-none {
    display: none;
  }
`;

export const Container = styled.div`
  ${responsiveWidth}
  width: 100%;
  margin: 0 auto;
  padding: 20px 0 14px;
`;

export const CollapseWrapper = styled.div``;

/* 회사정보 — 레퍼런스: 3줄, 항목은 | 로 구분 */
export const InfoBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

export const InfoRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  font-family: ${FONT};
  font-size: 13px;
  line-height: 1.7;
  letter-spacing: -0.02em;
  color: #b5b5b5;

  .strong {
    font-weight: 700;
    color: #e8e8e8;

    .key {
      font-weight: 700;
      color: #e8e8e8;
    }
  }

  .key {
    color: #9a9a9a;
  }

  &.sub,
  .sub {
    color: #9a9a9a;
  }
`;

export const Pipe = styled.span`
  flex-shrink: 0;
  padding: 0 10px;
  color: #5a5a5a;
  user-select: none;
`;

export const Divider = styled.div`
  border-top: 1px solid rgba(255, 255, 255, 0.08);
  margin: 16px 0 14px;
`;

/* 하단 약관 & 패밀리 사이트 Row */
export const BottomBar = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 18px;

  @media (max-width: 767px) {
    flex-direction: column;
    align-items: stretch;
    gap: 14px;
  }
`;

export const TermsList = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 10px 14px;
  align-items: center;
  flex: 1;
  min-width: 0;
`;

export const TermItem = styled.div`
  font-family: ${FONT};
  font-size: 13px;
  line-height: 1.4;
  letter-spacing: -0.02em;
  color: #b5b5b5;
  cursor: pointer;
  user-select: none;
  transition: color 0.15s ease;

  &:hover {
    color: #ffffff;
  }
`;

export const BottomRight = styled.div`
  position: relative;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 16px;

  @media (max-width: 767px) {
    justify-content: space-between;
  }
`;

export const SnsRow = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

export const SnsButton = styled.button`
  width: 36px;
  height: 36px;
  padding: 0;
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.08);
  color: #ffffff;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease;

  svg {
    width: 16px;
    height: 16px;
    stroke-width: 1.6;
  }

  &:hover {
    background: rgba(255, 255, 255, 0.16);
    border-color: rgba(255, 255, 255, 0.14);
  }
`;

export const TextMin = styled.div`
  font-family: ${FONT};
  font-size: 13px;
  line-height: 1.3;
  letter-spacing: -0.03em;
  text-align: left;
  color: #7a7a7a;
  margin-top: 12px;
  width: 100%;
`;

export const ContainerTerm = styled.div`
  position: relative;
  z-index: 1;
  width: 100%;
  margin: 0 auto;
`;
